import { Component, OnInit } from "@angular/core"
import { RouterOutlet } from "@angular/router"


@Component({
    selector: "uni-landing",
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: "./landing.component.html",
    styleUrls: ["./landing.component.scss"],
})
export class LandingComponent implements OnInit {
    
    constructor(
       
    ) {
        // Initialize the isDarkMode property with the value from the service
    }

  

    ngOnInit() {
       
    }

    
}
